import {debounce} from "./debounce";

const scrollObserver = ({
                            items,
                            rootMargin = "-150px 0px",
                            threshold = 0.05,
                            targetClass = "animated",
                            instance = {}
                        }) => {
    if (!items || items.length === 0) return;

    let options = {
        root: null,
        rootMargin,
        threshold,
    };

    let observer = new IntersectionObserver(beTouching, options);
    items.forEach(item => observer.observe(item));

    // Handle Items Intersecting
    function beTouching(entries, ob) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add(targetClass);
                ob.unobserve(entry.target);
            }
        });
    }

    /**
     * Parallax
     * @type {string}
     */
    let parallaxItems = document.querySelectorAll('.parallax');
    if (parallaxItems.length) {
        const handleParallaxScroll = () => {
            parallaxItems.forEach((item) => {
                const parallaxValue = item.dataset.parallax ?? 20
                const direction = item.dataset.direction === 'down' ? -1 : 1
                let dataParallax = item.getBoundingClientRect().top / parallaxValue * direction + 'px';
                item.style.transform = 'translate3d(0, ' + dataParallax + ', 0)';
            });
        }
        handleParallaxScroll();
        const onScroll = debounce(() => handleParallaxScroll(), 6);
        window.addEventListener("scroll", onScroll);
    }
}

export default scrollObserver;
